import { useState } from "react";
import { motion } from "framer-motion";
import { Volume2 } from "lucide-react";
import { useT } from "@/i18n";
import { LumiMascot, SparkMascot } from "@/components/Mascots";
import { playExclusive } from "@/components/SpeakButton";

const LINES = {
  lumi: { es: "¡Hola! Soy Lumi", en: "Hi! I'm Lumi" },
  spark: { es: "¡Y yo soy Spark!", en: "And I'm Spark!" },
};

export default function HelloMascot({ mascot, delay = 0 }) {
  const { lang } = useT();
  const [talking, setTalking] = useState(false);
  const Mascot = mascot === "lumi" ? LumiMascot : SparkMascot;
  const say = () => {
    const audio = new Audio(`/audio/${mascot}-hello-${lang === "en" ? "en" : "es"}.mp3?v=6`);
    audio.addEventListener("play", () => setTalking(true));
    audio.addEventListener("ended", () => setTalking(false));
    audio.addEventListener("pause", () => setTalking(false));
    playExclusive(audio, `hello-${mascot}`).catch(() => setTalking(false));
  };
  return (
    <button type="button" onClick={say} className="relative flex flex-col items-center cursor-pointer focus:outline-none" data-testid={`hello-${mascot}`} aria-label={LINES[mascot][lang] || LINES[mascot].es}>
      <motion.span initial={{ opacity: 0, scale: 0.6, y: 10 }} animate={{ opacity: 1, scale: talking ? 1.08 : 1, y: 0 }} transition={{ delay, type: "spring", stiffness: 220 }}
        className={`relative mb-2 inline-flex items-center gap-1.5 rounded-2xl px-3 sm:px-4 py-1.5 sm:py-2 font-fredoka font-bold text-sm sm:text-lg shadow-lg border-4 ${mascot === "lumi" ? "bg-yellow-300 border-white text-blue-950" : "bg-blue-600 border-white text-white"}`}
        data-testid={`hello-bubble-${mascot}`}>
        <Volume2 className={`w-4 h-4 sm:w-5 sm:h-5 ${talking ? "animate-pulse" : ""}`} /> {LINES[mascot][lang] || LINES[mascot].es}
        <span className={`absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-4 rotate-45 border-b-4 border-r-4 border-white ${mascot === "lumi" ? "bg-yellow-300" : "bg-blue-600"}`} />
      </motion.span>
      <motion.span animate={talking ? { y: [0, -12, 0], rotate: [0, -4, 4, 0] } : { y: 0 }} transition={talking ? { duration: 0.6, repeat: Infinity } : {}}>
        <Mascot size={230} className="w-28 sm:w-44 lg:w-[230px]" />
      </motion.span>
    </button>
  );
}
